import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';
import { syncDocumentLang } from './i18n';

// Keep <html lang="…"> in sync with the active UI language so VoiceOver,
// Safari Reader, and translate prompts see the right locale.
syncDocumentLang();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
